<template>
  <vs-popup class="user-edit-popup" id="popup" :title="!!prospect_customer_id ? 'UPDATE PROSPECT CUSTOMER' : 'CREATE PROSPECT CUSTOMER'" @close="open = false" :active.sync="open"
    :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateStaffUser)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="email" name="email" rules="required" v-slot="{ errors }">
                <small class="label">Email</small>
                <vs-input v-model="createStaffForm.email" name="email" class="w-full required" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="first_name" name="first_name" rules="required" v-slot="{ errors }">
                <small class="label">First Name</small>
                <vs-input v-model="createStaffForm.first_name" name="first_name" class="w-full required" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="last_name" name="last_name" rules="required" v-slot="{ errors }">
                <small class="label">Last Name</small>
                <vs-input v-model="createStaffForm.last_name" name="last_name" class="w-full required" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="company_name" name="company_name" rules="required" v-slot="{ errors }">
                <small class="label">Company Name</small>
                <vs-input v-model="createStaffForm.company_name" name="company_name" class="w-full required" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="country" name="country" rules="" v-slot="{ errors }">
                <small class="label">Country</small>
                <v-select :clearable="false" label="name" v-model="createStaffForm.country"
                  :reduce="option => option.name" :options="countryCodes">
                  <template v-slot:option="option">
                    <span>{{ option.name }} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="account_currency" name="account_currency" rules="required" v-slot="{ errors }">
                <small class="label">Currency</small>
                <v-select :disabled="!!prospect_customer_id" :clearable="false" label="code" v-model="createStaffForm.trading_currency" :reduce="option => option.code" :options="currencyList">
                  <template v-slot:option="option">
                    <span>{{option.code}} - {{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0 hidden">
              <ValidationProvider vid="start_date" name="start_date" rules="" v-slot="{ errors }">
                <small class="label">Account Handler</small>
                <v-select :clearable="false" label="first_name" v-model="createStaffForm.account_handler_id"
                  :reduce="option => option.id" :options="account_handlers">
                  <template v-slot:option="option">
                    <span>{{ option.first_name }} - {{ option.email }} </span>
                  </template>
                </v-select>
              </ValidationProvider>
            </div>
          </div>
          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="comment" name="comment" rules="" v-slot="{ errors }">
                <small class="label">Comments</small>
                <vs-textarea class="mb-0" v-model="createStaffForm.comment" height="150px" />
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const ProspectCustomerRepository = RepositoryFactory.get('prospect_customer')
const CurrencyRepository = RepositoryFactory.get('currency');
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import vSelect from 'vue-select'
const CountryCodeRepository = RepositoryFactory.get('countryCode');
const UserRepository = RepositoryFactory.get('user');
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

function initialState() {
  return {
    open: false,
    createStaffForm: {},
    currencyList: [],
    countryCodes: [],
    account_handlers: [],
    tenant_id: null,
    prospect_customer_id: null
  }
}

export default {
  name: 'CreateProspectCustomerPopUp',
  data() {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    'v-select': vSelect,
    flatPickr,
  },

  methods: {
    async openPopup(id) {
      try {
        Object.assign(this.$data, initialState())
        this.tenant_id = this.$route.params.id
        this.$refs.form.reset();
        await this.loadCountryCodes()
        await this.fetchCountryList()
        await this.fetchUsers()
        if(!!id) {
          this.prospect_customer_id = id
          await this.fetchProspectCustomer()
        }
        this.open = true;
      } catch (error) {
        console.log("error", error)
      }
    },
    async fetchCountryList(){
      const {data} = await CurrencyRepository.getCurrencyList()
      this.currencyList = data.data
    },
    async fetchProspectCustomer() {
      try {
        const { data } = (await ProspectCustomerRepository.getProspectCustomer(this.prospect_customer_id)).data
        this.createStaffForm = data
      } catch (error) {
        
      }
    },
    async onClickCreateStaffUser() {
      const vue = this;
      this.$vs.loading()
      try {
        if(this.prospect_customer_id) {
          await ProspectCustomerRepository.updateProspectCustomer(this.prospect_customer_id, this.createStaffForm)
        } else {
          await ProspectCustomerRepository.createProspectCustomer(this.createStaffForm)
        }
        await vue.$parent.refreshData()
        this.open = false;
      } catch (e) {
        this.$vs.loading.close()
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async loadCountryCodes() {
      const { data } = await CountryCodeRepository.get()
      this.countryCodes = data.data
    },
    async fetchUsers() {
      const { data } = (await UserRepository.get(1, '', 150, '')).data
      this.account_handlers = data
    },
    onClickReset() {
      this.createStaffForm = {}
    }
  },
}
</script>

<style scoped>
.video-wrapper {
  width: 100%;
  height: 100%;
}

.video-wrapper video {
  object-fit: cover;
  width: 100%;
  height: 100%;

}

.image-wrapper {
  width: 100%;
  height: 75%;
}
</style>
